import { render, staticRenderFns } from "./ProgramStatus.vue?vue&type=template&id=c126da3c&scoped=true&"
import script from "./ProgramStatus.vue?vue&type=script&lang=ts&"
export * from "./ProgramStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramStatus.vue?vue&type=style&index=0&id=c126da3c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c126da3c",
  null
  
)

export default component.exports